import { Middleware } from 'redux'

import { errorCodeMap, httpStatusMap }                                from '../../utils'
import { failedRequest, RequestAction, requested, successfulRequest } from '../ducks'

function isRequestAction ({ meta }: any): boolean {
  return meta && meta.request
}

const requestMiddleware: Middleware = store => next => (action: RequestAction) => {
  next(action)

  if (!isRequestAction(action)) return

  const { payload: { args }, meta: { request, namespace, successHandler } } = action

  store.dispatch(requested(namespace))

  let error

  request(...args)
  /* TODO: are all swagger resolved promised parsed as JSON by default? */
    .then(response => {
      /*
       * for the communication reducer to clean up specific communications
       * */
      store.dispatch(successfulRequest(namespace))

      /*
       * if no action to be dispatched / actionCreator was specified to handle
       * the response we warn (because the communication handler shouldn't ever be enough)
       * and then return from this middleware
       * */
      if (!successHandler) {
        console.warn(
          `[${namespace}] request has successfully received`
          + 'a response but no handler for it was provided',
        )
        return
      }

      let successAction

      if (typeof successHandler === 'function') {
        successAction = successHandler(response, ...args)
      } else {
        successAction = successHandler
      }

      store.dispatch(successAction)
    })
    /*
     * just for the communication reducer to update the
     * namespaced communication-entry to an error state
     * */
    .catch(e => {

      /*
       * This is for development since an error that is thrown during synchronous execution
       * inside the then block due to a bug in the program say in a reducer for example is
       * caught here and that's kind of bad since this catch is only intended for communication
       * errors but it's just the way promises work
       * */
      console.log(e)

      error = httpStatusMap[ e.status ] || String(e)

      if (!e.json) {
        store.dispatch(failedRequest(namespace, e))
      } else {
        e.json()
         .catch((e) => {
          console.log(e)
           /*
           * for JSON parsing errors intended to catch an http error that has no response
           * body and just dispatch the failedRequest action with the http-mapped error
           * */
         })
         .then(e => {

           /*
           * if there was a parse-able error in the response and that error has either
           *
           * an 'error' property (custom error)
           *
           * or
           *
           * a 'code' property (swagger gen'd)
           * */
           if (e && (e.error || e.code)) {
             const i18ErrorCode = errorCodeMap[ e.code || e.error.code ]

             /* if the mapping exists assign it to 'error' */
             error = i18ErrorCode ? i18ErrorCode : error
           }

           /* for development */
           console.log(e)

           store.dispatch(failedRequest(namespace, error))
         })
      }
    })
}

export default requestMiddleware



// WEBPACK FOOTER //
// ./src/redux/middlewares/request.middleware.ts